

const Media = ({ media }) => {
  const data = media;

  const handleImageClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="flex flex-col w-full mt-2">
      <div className="w-full bg-white p-2 ">
        <div className="flex justify-between items-center mb-4 ">
          <h2 className="text-lg font-semibold">Post Performance</h2>
          <select className="border text-sm px-2 py-1 rounded">
            <option>Last 7 days</option>
            <option>Last 30 days</option>
          </select>
        </div>
        <div className="w-full">
          <table className="w-full text-xs sm:text-sm text-left">
            <thead className="border-b text-gray-500">
              <tr>
                <th className="px-2 sm:px-4 py-2">Post</th>
                <th className="px-2 sm:px-4 py-2">caption</th>
                <th className="px-2 sm:px-4 py-2">Views</th>
                <th className="px-2 sm:px-4 py-2">Likes</th>
                <th className="px-2 sm:px-4 py-2">Comments</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.mediaId} className="border-b hover:bg-gray-50">
                  <td className="px-2 sm:px-4 py-2">
                    <img
                      src={item.thumbnailUrl}
                      alt="thumbnail"
                      className="w-12 h-12 sm:w-14 sm:h-14 rounded object-cover cursor-pointer"
                      onClick={() => handleImageClick(item.mediaUrl)}
                    />
                  </td>
                  <td className="px-2 sm:px-4 py-2 max-w-[120px] sm:max-w-xs truncate">
                    <p className="mb-0 ">{item.caption}</p>
                    </td>
                   
                  <td className="px-2 sm:px-4 py-2">{item.views}</td>
                  <td className="px-2 sm:px-4 py-2">{item.likes}</td>
                  <td className="px-2 sm:px-4 py-2">{item.comments}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Media;